// all routes

import React from "react"
import { Navigate } from "react-router-dom"

// Dashboard
import Dashboard from "../pages/Dashboard/dashboard"

// Staff
import Staff from "../pages/Staff/staff";
import WorkSchedule from "../pages/Staff/work-schedule";

// Services
import ServicesList from "../pages/Services/services-list";

// Bookings
import Bookings from "../pages/Bookings/bookings";

// Payment
import Payment from "../pages/Payment/payment";
import PaymentSubscriptions from 'pages/PaymentSubscriptions/payment-subscriptions';

// Cash
import Cash from "../pages/Cash/cash";

// Fields
import TemplateFields from "../pages/Templates/template-fields";

// Subscriptions
import Subscriptions from "../pages/Subscriptions/subscriptions";

// Procuratory
import Procuratory from "../pages/Outstaffing/procuratory";

// Договоры клиентов
import Contracts from "../pages/Outstaffing/contracts";

// Заказы в договорах
import ContractOrders from "../pages/Outstaffing/contractOrders";

// Store
import StoreGoods from "../pages/StoreGoods/storeGoods";
import StoreGoodsSize from "../pages/StoreGoods/storeGoodsSize";
import StoreGoodsCategory from "../pages/StoreGoods/storeGoodsCategory";
import StoreGoodsMaterial from "../pages/StoreGoods/storeGoodsMaterial";
import StoreGoodsName from "../pages/StoreGoods/storeGoodsName";

// Service requests
import ServiceRequests from "../pages/ServiceRequests/service-requests";
import ServiceRequestsOutstaff from "../pages/Outstaffing/service-requests-outstaff";

// Contacts
import CustomersList from "../pages/Customers/customers-list";

// Companies
import Companies from "../pages/Companies/companies";
import CompanyAddress from "../pages/Companies/company-address";

// Templates
import Template from "../pages/Templates/template";
import TemplatesSet from "../pages/Templates/templates-set";

// Glossary
import Glossary from "../pages/Glossary/glossary";

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"

// Profile
import ServicesAdd from 'pages/Services/ServicesAdd';
import Sanatera from 'pages/Online/Dogovora/Sanatera/sanatera';

// Статистика
import Statistics from 'pages/Statistics/statistics';

// Оплаты заказов в договорах
import ContractOrderPayments from 'pages/Outstaffing/contractOrderPayments';

const userRoutes = [
	{ path: "/dashboard", component: <Dashboard /> },

	// Staff
	{ path: "/staff", component: <Staff /> },
	{ path: "/work-schedule", component: <WorkSchedule /> },

	// Services
	{ path: "/services-list", component: <ServicesList /> },
	{ path: "/services-add", component: <ServicesAdd /> },

	// Service Requests
	{ path: "/service-requests", component: <ServiceRequests /> },
	{ path: "/service-requests-outstaff", component: <ServiceRequestsOutstaff /> },

	// Bookings
	{ path: "/bookings", component: <Bookings /> },

	// Payment
	{ path: "/payment", component: <Payment /> },
	{ path: "/payment-subscriptions", component: <PaymentSubscriptions /> },

	// Cash
	{ path: "/cash", component: <Cash /> },

	// Subscriptions
	{ path: "/subscriptions", component: <Subscriptions /> },

	// Procuratory
	{ path: "/procuratory", component: <Procuratory /> },

	// Store
	{ path: "/storeGoods", component: <StoreGoods /> },
	{ path: "/storeGoodsSize", component: <StoreGoodsSize /> },
	{ path: "/storeGoodsCategory", component: <StoreGoodsCategory /> },
	{ path: "/storeGoodsMaterial", component: <StoreGoodsMaterial /> },
	{ path: "/storeGoodsName", component: <StoreGoodsName /> },

	// Договоры аутстафф 
	{ path: "/contracts", component: <Contracts /> },

	// Заказы в договорах
	{ path: "/contractOrders", component: <ContractOrders /> },

	// Contacts
	{ path: "/customers-list", component: <CustomersList /> },

	// Companies
	{ path: "/companies", component: <Companies /> },
	{ path: "/company-address", component: <CompanyAddress /> },

	// Templates
	{ path: "/template", component: <Template /> },
	{ path: "/template-fields", component: <TemplateFields /> },
	{ path: "/templates-set", component: <TemplatesSet /> },

	// Glossary
	{ path: "/glossary", component: <Glossary /> },

	// Statistics
	{ path: "/statistics", component: <Statistics /> },

	// Оплаты заказов в договорах
	{ path: "/contractOrderPayments", component: <ContractOrderPayments /> },

	// this route should be at the end of all other routes
	// eslint-disable-next-line react/display-name
	{
		path: "/",
		exact: true,
		component: <Navigate to="/dashboard" />,
	},
	{ path: "*", component: <Navigate to="/dashboard" /> },
];

const authRoutes = [
	{ path: "/logout", component: <Logout /> },
	{ path: "/login", component: <Login /> },
	// Online
	// { path: "online/dogovora/sanatera", component: <Sanatera /> },
]

export { userRoutes, authRoutes }